/**
 * @file: TaskStatusUpdateType.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */
export enum TaskStatusUpdateType {
  Finished = 'finished',
  Cancelled = 'cancelled',
  Rollback = 'rollback',
}
